<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <image-upload
        v-model="image"
        :width="375"
        :height="204"
        @formData-updated="imageUploaded"
        @file-removed="imageRemoved"
      ></image-upload>

      <div
        v-if="imageMissing"
        class="error--text text-caption mt-2"
      >
        Загрузите изображение акции
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-text>
      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <date-range
              v-model="dateRange"
              :rules="[rules.required]"
            ></date-range>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="sortIndex"
              :rules="[rules.required]"
              dense
              outlined
              label="Индекс сортировки"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-checkbox
              v-model="isBanner"
              label="Баннер"
              :error="hasErrorsForProperty(errors.errors, 'isBanner')"
              :error-messages="errorMessages(errors.errors, 'isBanner')"
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="contacts"
              :items="contactsDropdown"
              :menu-props="{ maxHeight: '400' }"
              label="Контакты"
              multiple
              :error="hasErrorsForProperty(errors.errors, 'contacts')"
              :error-messages="errorMessages(errors.errors, 'contacts')"
              dense
              outlined
              persistent-hint
              hide-details
            ></v-select>
          </v-col>

          <v-spacer></v-spacer>

          <v-col
            md="12"
            cols="24"
          >
            <translation-fields
              v-model="translations"
              :fields="translatedFields"
            />
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import DatePicker from '@/components/date-picker'
import { rules } from '@/helpers/validation'
import TranslationFields from '@/components/translation-fields'
import DateRange from '@/components/date-range'
import ImageUpload from '@/components/image-upload.vue'
import { hasErrorsForProperty, errorMessages } from '@/helpers'

export default {
  name: 'PromotionForm',
  components: {
    TranslationFields, DatePicker, DateRange, ImageUpload,
  },
  props: ['save', 'show'],
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    translatedFields: [
      { key: 'name', label: 'Наименование', required: true },
      { key: 'subtitle', label: 'Подзаголовок' },
      { key: 'description', label: 'Описание', rich: true },
    ],
    rules,

    newImage: null,
    imageMissing: false,
    hasErrorsForProperty,
    errorMessages,
  }),
  computed: {
    ...mapFormHandlers('promotion/form', [
      'translations',
      'publicationDate',
      'contacts',
      'image',
      'sortIndex',
      'isBanner',
      'endDate',
      'dateRange',
    ]),
    ...mapGetters('dictionary', { contactsDropdown: 'contactsDropdown' }),
  },
  async mounted() {
    await this.fetchContacts()
  },
  methods: {
    imageUploaded(blob) {
      this.newImage = blob
    },
    imageRemoved() {
      this.newImage = null
    },
    cancel() {
      this.resetForm()
      this.$router.back()
    },
    ...mapActions('promotion/form', ['resetForm']),
    ...mapActions('dictionary', { fetchContacts: 'fetchContacts' }),
    async saveData() {
      this.imageMissing = !this.newImage && !this.image

      if (this.imageMissing) {
        return
      }

      if (this.$refs.form.validate()) {
        await this.save(this.newImage)
      }
    },
  },
}
</script>
